import type { JobFilters } from '@/features/jobs/types/job-filters'
import type { Job } from '@/features/jobs/types/job'
import {
  DEFAULT_JOB_LIST_SORT,
  type JobListSort,
} from '@/features/jobs/lib/job-list-sort'
import { apiPaginatedClient } from '@/lib/api/api-client'
import { appendSortParams } from '@/lib/column-sort'

const buildJobsQuery = (
  filters?: JobFilters,
  page = 1,
  sort: JobListSort = DEFAULT_JOB_LIST_SORT
) => {
  const params = new URLSearchParams()

  if (filters) {
    const dateRaised = filters.date_raised.trim()
    const location = filters.location.trim()
    const completedAt = filters.completed_at.trim()

    if (dateRaised) {
      params.set('date_raised', dateRaised)
    }

    if (location) {
      params.set('location', location)
    }

    if (filters.job_type) {
      params.set('job_type', filters.job_type)
    }

    if (filters.raised_by_user_id) {
      params.set('raised_by_user_id', String(filters.raised_by_user_id))
    }

    if (filters.assigned_partner_id) {
      params.set('assigned_partner_id', String(filters.assigned_partner_id))
    }

    if (filters.status) {
      params.set('status', filters.status)
    }

    if (filters.severity) {
      params.set('severity', filters.severity)
    }

    if (filters.outcome) {
      params.set('outcome', filters.outcome)
    }

    if (completedAt) {
      params.set('completed_at', completedAt)
    }

    if (filters.completed_by_user_id) {
      params.set('completed_by_user_id', String(filters.completed_by_user_id))
    }
  }

  params.set('page', String(page))
  appendSortParams(params, sort, DEFAULT_JOB_LIST_SORT)

  const query = params.toString()

  return `?${query}`
}

export const apiGetJobs = (
  filters?: JobFilters,
  page = 1,
  sort: JobListSort = DEFAULT_JOB_LIST_SORT
) =>
  apiPaginatedClient<Job[]>(`/api/v1/jobs${buildJobsQuery(filters, page, sort)}`)
